import { ListProps, Paging } from '@Core';
import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { AxiosInstance } from 'axios';
import {
    ContraventionProcessingJob,
    ContraventionProcessingJobGroupByOutCome,
} from '../../model/ContraventionProcessingJob';
import {
    IContraventionProcessingJobHttpController,
    IFilterContraventionProcessingJob,
} from '../IContraventionProcessingJobHttpController';

export class ContraventionProcessingJobHttpController
    extends BaseHttpController<ContraventionProcessingJob>
    implements IContraventionProcessingJobHttpController
{
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'contravention-processing-job', client);
    }

    async list(props: IFilterContraventionProcessingJob): Promise<Paging<ContraventionProcessingJobGroupByOutCome>> {
        return await this.doPost({ path: 'filter', body: props }).then((res) => res.data);
    }

    async deleteContraventionProcessingJob(props: { ContraventionProcessingJobId: number }): Promise<boolean> {
        return await this.doPost({ path: 'delete', body: props }).then((res) => res.data);
    }
}
